import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconV2 } from "../../../icon_v2";
export const CardV2 = ({ children, isSelected = false, variant = "default", onClick, className = "", showCheckmark = false, header, headerClassName = "", noPadding = false, headerBorder = false, }) => {
    // `button` option needs work.
    // There are issues with fixed heights on buttons.
    const Element = onClick ? "button" : "div";
    const getVariantClasses = () => {
        switch (variant) {
            case "selected":
                return "border-blue-500 bg-blue-50 dark:border-[#2466B3] dark:bg-[#10213A]";
            case "warning":
                return "border-amber-500 bg-amber-50 dark:border-[#B38624] dark:bg-[#3A2F10]";
            case "danger":
                return "border-red-500 bg-red-50 dark:border-[#B32424] dark:bg-[#3A1010]";
            default:
                return isSelected
                    ? "border-[#1A93EF] bg-[#1A93EF]/10 dark:border-[#2466B3] dark:bg-[#10213A]"
                    : "border-gray-200 bg-white dark:border-[#23232D] dark:bg-[#23232D]";
        }
    };
    return (_jsx(Element, { className: `
        relative block w-full overflow-hidden rounded-lg border
        text-left transition-all duration-200
        ${onClick ? "cursor-pointer hover:bg-gray-50" : ""}
        ${getVariantClasses()}
        ${className}
      `, onClick: onClick, type: onClick ? "button" : undefined, children: _jsxs("div", { className: "flex flex-col", children: [header !== undefined && (_jsx("div", { className: `
              ${noPadding ? "" : "px-3 pt-3"}
              ${headerBorder
                        ? "border-b border-gray-200 dark:border-[#23232D]"
                        : ""}
              ${headerClassName}
              dark:bg-[#23232D]
            `, children: header })), _jsxs("div", { className: `card-body flex flex-1 ${noPadding ? "" : "px-3 pb-3"} dark:bg-[#23232D]`, children: [children, showCheckmark && isSelected && (_jsx("div", { className: "absolute right-2 top-3", children: _jsx(IconV2, { type: "fa", icon: {
                                    icon: ["fas", "circle-check"],
                                    fixedWidth: true,
                                    size: "lg",
                                }, color: "blue" }) }))] })] }) })
    // <Element
    //   className={`
    //     relative block w-full overflow-hidden rounded-lg border
    //     text-left transition-all duration-200
    //     ${onClick ? 'cursor-pointer hover:bg-gray-50' : ''}
    //     ${getVariantClasses()}
    //     ${className}
    //   `}
    //   onClick={onClick}
    //   type={onClick ? 'button' : undefined}
    // >
    //   <div className="flex flex-col">
    //     {header !== undefined && (
    //       <div
    //         className={`
    //           ${!noPadding ? 'px-4 py-3' : ''}
    //           ${headerBorder ? 'border-b border-gray-200' : ''}
    //           ${headerClassName}
    //         `}
    //       >
    //         {header}
    //       </div>
    //     )}
    //     <div className={`card-body flex flex-1 ${!noPadding ? 'px-4 py-3' : ''}`}>
    //       {children}
    //       {showCheckmark && isSelected && (
    //         <div className="absolute right-2 top-3">
    //           <div className="bg-blue-500 text-white rounded-full p-1">
    //             <Check size={16} />
    //           </div>
    //         </div>
    //       )}
    //     </div>
    //   </div>
    // </Element>
    );
};
export default CardV2;
